import { baseApi } from './base';
import { AutocompletePayload, AutocompleteResponse } from '../domain/address';

export const autocompleteApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAddresses: builder.mutation<AutocompleteResponse, AutocompletePayload>({
      query: ({ search, selected }) => ({
        method: 'POST',
        url: 'qualification/street_address/autocomplete',
        data: {
          search,
          selected,
        },
      }),
    }),
  }),
});

export const { useGetAddressesMutation } = autocompleteApi;
